var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.393079 14.915C0.511711 14.9781 0.644908 15.007 0.778372 14.9986C0.911837 14.9901 1.04053 14.9446 1.15064 14.867L10.6843 8.11667C10.7817 8.04765 10.8613 7.9555 10.9163 7.84813C10.9713 7.74075 11 7.62135 11 7.50014C11 7.37893 10.9713 7.25953 10.9163 7.15215C10.8613 7.04478 10.7817 6.95264 10.6843 6.88361L1.15064 0.133254C1.04061 0.0553944 0.911863 0.00980133 0.778322 0.0014114C0.644781 -0.00697854 0.511541 0.0221545 0.393028 0.085656C0.274515 0.149157 0.175245 0.244607 0.105968 0.361671C0.0366905 0.478735 4.51626e-05 0.612951 9.96127e-09 0.749786V14.2505C-2.20501e-05 14.3874 0.0365968 14.5217 0.105887 14.6389C0.175178 14.756 0.274497 14.8515 0.393079 14.915Z",
    fill: "#4589DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.aeb04d50.svg";
export { ForwardRef as ReactComponent };